export default "__VITE_ASSET__Bw6BUYDW__"